import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Survey, Question, ClassMapper, CacheService } from 'mapfre-auditlib';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {

  className = 'SurveyService';

  constructor(private http: HttpClient, private translateService: TranslateService, private cacheService: CacheService) {
  }

  getAllSurveys(): Observable<Survey[]> {
    return this.http.get<Survey[]>(environment.base_URL + "/questionnaires")
  }

  getSurveyByID(id): Observable<Survey> {
    return this.getAllSurveys().pipe(map<Survey[], Survey>(res => _.find(res, ['ID', id])));
  }

  getQuestionsSurvey(id): Observable<Question[]> {
    return this.http.get<Question[]>(environment.base_URL + `/questionnaires/${id}/questions`).pipe(map(res => {
      return ClassMapper.fromJSONArray(res, Question);
    }))
  }

  updateQuestionsSurvey(questions: Question[], id) {
    return this.http.put(environment.base_URL + `/questionnaires/version/${id}`, questions);
  }

  newSurvey(newSurvey) {
    return this.http.post(environment.base_URL + "/questionnaires", newSurvey);
  }

  updateSurvey(editedSurvey, id) {
    return this.http.put(environment.base_URL + `/questionnaires/${id}`, editedSurvey)
  }

  getSurveyTypes(cache = true, cacheKey = "surveyTypes"): Observable<[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable = this.http.get<[]>(environment.base_URL + "/types-questionnaire").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

}
